(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ActionSDK", [], factory);
	else if(typeof exports === 'object')
		exports["ActionSDK"] = factory();
	else
		root["ActionSDK"] = factory();
})(window, function() {
return 